/* ============================================================
   Clear PDF Guide — theme.js
   Vanilla JS. Cart drawer (AJAX), product gallery, variant
   selection, quantity steppers, mobile nav, accordions.
   ============================================================ */
(function () {
  "use strict";

  const money = (cents) => {
    const code = window.themeCurrency || "USD";
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  };

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    const toggle = $(".header__menu-toggle");
    const nav = $(".header__nav-mobile");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---------------- Cart drawer ---------------- */
  const Cart = {
    drawer: null,
    overlay: null,
    init() {
      this.drawer = $("#CartDrawer");
      this.overlay = $("#CartOverlay");
      if (!this.drawer) return;
      $$("[data-cart-close]").forEach((b) => b.addEventListener("click", () => this.close()));
      if (this.overlay) this.overlay.addEventListener("click", () => this.close());
      document.addEventListener("keydown", (e) => { if (e.key === "Escape") this.close(); });
    },
    open() {
      if (!this.drawer) return;
      this.drawer.classList.add("is-open");
      this.overlay && this.overlay.classList.add("is-open");
      this.drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    },
    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      this.overlay && this.overlay.classList.remove("is-open");
      this.drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    },
    async refresh() {
      try {
        const res = await fetch("/?section_id=cart-drawer");
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, "text/html");
        const fresh = html.querySelector("#CartDrawer .cart-drawer__contents");
        const cur = $("#CartDrawer .cart-drawer__contents");
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        this.bindItemEvents();
      } catch (e) { console.warn("cart refresh failed", e); }
      this.updateCount();
    },
    async updateCount() {
      try {
        const res = await fetch("/cart.js");
        const cart = await res.json();
        $$("[data-cart-count]").forEach((el) => { el.textContent = cart.item_count; });
      } catch (e) { /* noop */ }
    },
    bindItemEvents() {
      $$("[data-cart-remove]", this.drawer).forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          this.change(btn.dataset.cartRemove, 0);
        });
      });
      $$("[data-qty-change]", this.drawer).forEach((btn) => {
        btn.addEventListener("click", () => {
          this.change(btn.dataset.key, parseInt(btn.dataset.qtyChange, 10));
        });
      });
    },
    async change(key, qty) {
      try {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        await this.refresh();
      } catch (e) { console.warn(e); }
    },
    async add(form) {
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : "";
      if (btn) { btn.classList.add("is-disabled"); btn.textContent = "Adding…"; }
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw data;
        if (window.themeSettings && window.themeSettings.cartType === "drawer") {
          await this.refresh();
          this.open();
        } else {
          window.location.href = window.routes ? window.routes.cart_url : "/cart";
          return;
        }
      } catch (err) {
        const msg = (err && err.description) || "Could not add to cart.";
        const note = form.querySelector("[data-form-error]");
        if (note) { note.textContent = msg; note.hidden = false; }
        else alert(msg);
      } finally {
        if (btn) { btn.classList.remove("is-disabled"); btn.textContent = original; }
      }
    },
  };

  function initAddToCart() {
    $$("form[action$='/cart/add'], form[data-cart-add]").forEach((form) => {
      form.addEventListener("submit", (e) => {
        if (window.themeSettings && window.themeSettings.cartType === "page" && !form.dataset.cartAjax) return;
        e.preventDefault();
        Cart.add(form);
      });
    });
    $$("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); Cart.open(); }));
  }

  /* ---------------- Quantity steppers ---------------- */
  function initQty() {
    $$(".qty").forEach((wrap) => {
      const input = wrap.querySelector("input");
      if (!input) return;
      wrap.querySelectorAll("button").forEach((btn) => {
        btn.addEventListener("click", () => {
          const step = btn.dataset.dir === "down" ? -1 : 1;
          const v = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    $$("[data-gallery]").forEach((gallery) => {
      const main = gallery.querySelector("[data-gallery-main]");
      const thumbs = $$("[data-gallery-thumb]", gallery);
      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          const src = thumb.dataset.full;
          const alt = thumb.dataset.alt || "";
          if (main && src) { main.src = src; main.alt = alt; }
          thumbs.forEach((t) => t.classList.remove("is-active"));
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* ---------------- Variant selection ---------------- */
  function initVariants() {
    $$("[data-product-form]").forEach((form) => {
      const dataEl = form.querySelector("[data-variant-json]");
      if (!dataEl) return;
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const idInput = form.querySelector("[data-variant-id]");
      const priceEl = document.querySelector("[data-price-current]");
      const compareEl = document.querySelector("[data-price-compare]");
      const submit = form.querySelector('[type="submit"]');

      function selectedOptions() {
        const opts = [];
        $$("[data-option-index]", form).forEach((el) => {
          if (el.type === "radio") { if (el.checked) opts[parseInt(el.dataset.optionIndex, 10)] = el.value; }
          else opts[parseInt(el.dataset.optionIndex, 10)] = el.value;
        });
        return opts;
      }
      function update() {
        const optionEls = $$("[data-option-index]", form);
        let match;

        if (optionEls.length === 0) {
          // Single-variant / default-variant product (e.g. a digital PDF).
          // There is nothing to pick, so just use the variant already in the form.
          const currentId = idInput ? parseInt(idInput.value, 10) : null;
          match = variants.find((v) => v.id === currentId) || variants[0];
        } else {
          const sel = selectedOptions();
          match = variants.find((v) => v.options.every((o, i) => o === sel[i]));
        }

        if (!match) {
          if (submit) {
            submit.textContent = "Unavailable";
            submit.classList.add("is-disabled");
            submit.disabled = true;
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false;
          } else compareEl.hidden = true;
        }
        if (submit) {
          if (match.available) {
            submit.textContent = submit.dataset.addLabel || "Add to cart";
            submit.classList.remove("is-disabled");
            submit.disabled = false;
          } else {
            submit.textContent = "Sold out";
            submit.classList.add("is-disabled");
            submit.disabled = true;
          }
        }

        // Only rewrite the URL when the shopper actually picked a variant.
        if (optionEls.length > 0) {
          const url = new URL(window.location);
          url.searchParams.set("variant", match.id);
          window.history.replaceState({}, "", url);
        }
      }
      $$("[data-option-index]", form).forEach((el) => el.addEventListener("change", update));
      update();

      // Re-run when the theme editor re-renders a section, so the editor
      // preview matches the live storefront instead of masking bugs.
      document.addEventListener("shopify:section:load", update);
    });
  }

  /* ---------------- Newsletter / contact inline status ---------------- */
  function initFormScroll() {
    const hash = window.location.hash;
    if (hash && (hash.indexOf("contact") > -1 || hash.indexOf("newsletter") > -1)) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView ? el.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMobileNav();
    Cart.init();
    initAddToCart();
    initQty();
    initGallery();
    initVariants();
  });

  window.theme = window.theme || {};
  window.theme.cart = Cart;
})();